import { AbstractControl } from '@angular/forms';

export function timeRangeValidator(start: string, end: string) {
  return (form: AbstractControl) => {
    const startTime = form.get(start)?.value;
    const endTime = form.get(end)?.value;

    if (!startTime || !endTime) {
      return null;
    }

    return startTime > endTime ? { invalidTimeRange: true } : null;
  };
}